import { Typography } from '@mui/material';

export default function Required() {
  return (
    <Typography component="span" className="ml-4 font-600 text-typography-danger">
      *
    </Typography>
  );
}
